import Animation from './animation'
import * as d3 from 'd3-selection'
import * as scale from 'd3-scale'
import * as array from 'd3-array'
import { EPSILON } from 'chart-constants'

class HierarchyDrillupAnimation extends Animation {

  match (serie) {
    if (!this.exitingSeries.size()) {
      return false
    }

    let entering = this.series.selection().datum()
      , exiting = this.exitingSeries.selection().datum()
      , exitingBlocks = this.exitingSeries.selection().selectAll('.treemap-block').data()
      , enteringIds = entering.points.map(p => p.rangeId).filter(Boolean)
      , exitingParentIds = exitingBlocks.map(node => node.data.parentId).filter(Boolean)

    return exiting.parentId == entering.id ||
      array.intersection(enteringIds, exitingParentIds).size
  }

  animate (serie, enter, selection, merged, exit) {
    let newSerie = this.series.selection().datum()
      , self = this
      , blocks = this.series.selection().selectAll('.treemap-block').data()
      , exitingId = this.exitingSeries.selection().datum().id
      , exitingBlock = blocks.find(block => block.data.id === exitingId)
      , prevBlocks = this.exitingSeries.selection().selectAll('.treemap-block')

    if (exit.size()) {
      let xScale = scale.scaleLinear()
                        .domain([0, this.dimensions.width])
                        .rangeRound([exitingBlock.x0, exitingBlock.x1]) // Set the domain of our scalers to be the previous values
        , yScale = scale.scaleLinear()
                        .domain([0, this.dimensions.height])
                        .rangeRound([exitingBlock.y0, exitingBlock.y1])

      // TODO if exiting block isn't defined we need figure out what to do

      // Get the previous node's data
      // Update the position of the previous nodes so they blowup
      exit.attr('transform', d => `translate(${xScale(d.x0)}, ${yScale(d.y0)})`)
          .style('opacity', EPSILON)
          .selectAll('rect')
          .attr('width', d => xScale(d.x1) - xScale(d.x0))
          .attr('height', d => yScale(d.y1) - yScale(d.y0))

    } else {
      enter.each(function (d) {
        let prev = prevBlocks.data().find(prev => prev.data.id == d.data.id)

        if (prev) {
          let node = prevBlocks.filter(d => d.data.id == prev.data.id)
          // this block was previously visible. start it at the previous location
          d3.select(this)
            .style('opacity', 1)
            .attr('transform', d => `translate(${prev.x0}, ${prev.y0})`)
            .select('rect')
            .style('opacity', 1)
              .attr('fill', d => self.previousColorScale(prev.data.level))
              .attr('width', prev.x1 - prev.x0)
              .attr('height', prev.y1 - prev.y0)

          let label = node.select('.label')
          d3.select(this)
            .select('.label')
            .style('font-size', label.style('font-size'))
            .attr('transform', label.attr('transform'))

          node.style('opacity', EPSILON)
        } else {
          let xScale = scale.scaleLinear()
                            .domain([exitingBlock.x0, exitingBlock.x1]) // Set the domain of our scalers to be the previous values
                            .rangeRound([0, self.dimensions.width])
            , yScale = scale.scaleLinear()
                            .domain([exitingBlock.y0, exitingBlock.y1])
                            .rangeRound([0, self.dimensions.height])

          d3.select(this)
            .attr('transform', d => `translate(${xScale(d.x0)}, ${yScale(d.y0)})`)
            .select('rect')
             .attr('width', d => xScale(d.x1) - xScale(d.x0))
             .attr('height', d => yScale(d.y1) - yScale(d.y0))

          d3.select(this)
            .select('.label')
            .style('font-size', '0px')
        }
      })
      // transform new nodes to the correct location
      merged.attr('transform', d => `translate(${d.x0},${d.y0})`)
            .selectAll('rect')
            .attr('fill', d => this.colorScale(d.data.level))
            .attr('width', d => d.x1 - d.x0)
            .attr('height', d => d.y1 - d.y0)
      merged.call(this._labels)
    }

  }

}

export default HierarchyDrillupAnimation
